export default __webpack_public_path__ + "static/media/Blackshard.8d73204d.jpg";